<app-fuel-hourly-consumption-chart
  [width]="width"
  [height]="220"
  [dataSource]="hourlyRateDs"></app-fuel-hourly-consumption-chart>

<div class="py-2">
  <h3 class="font-light border-b border-gray-300 mb-2 py-1">Consommation</h3>
  <div class="grid p-1 grid-cols-3 gap-3 history-metrics">
    <div title="Instantanée" class="shadow-sm hover:shadow cursor-pointer">
      <div class="metric-text">Litres/Heure</div>
      <span class="metric-value">{{current.fuel_hourly_consumption_rate?.toFixed(3)}} <span
        class="metric-unit">L/h</span></span>
    </div>
    <div title="Instantanée" class="shadow-sm hover:shadow cursor-pointer">
      <div class="metric-text">Litres</div>
      <span class="metric-value">{{fuelTotal.toFixed(2)}} <span
        class="metric-unit">L</span></span>
    </div>
    <div title="Consommation Totale" class="shadow-sm hover:shadow cursor-pointer">
      <div class="metric-text">Totale Litres</div>
      <span class="metric-value">{{current.fuel_total_consumption?.toFixed(2)}} <span
        class="metric-unit">L</span></span>
    </div>
  </div>
</div>

<div>
  <h3 class="font-light border-b border-gray-300 mb-2 py-1">Compteurs</h3>
  <div class="grid p-1 grid-cols-3 gap-3 history-metrics">
    <div title="Heures Moteur" class="shadow-sm hover:shadow cursor-pointer">
      <div class="metric-text">Heures Moteur</div>
      <span class="metric-value">{{engineHours.toFixed(2)}} <span
        class="metric-unit">H</span></span>
    </div>
    <div title="Totale" class="shadow-sm hover:shadow cursor-pointer">
      <div class="metric-text">Totale Heures Moteur</div>
      <span class="metric-value">{{current.engine_hours.toFixed(2)}} <span
        class="metric-unit">H</span></span>
    </div>
    <div title="Temperature" class="shadow-sm hover:shadow cursor-pointer">
      <div class="metric-text">Temperature</div>
      <span class="metric-value">{{current.params.FuelTemperature}} <span
        class="metric-unit">°C</span></span>
    </div>
  </div>
</div>
